import { useMutation, useQueryClient } from '@tanstack/react-query'
import { OtpProviderService } from '@/modules/otp-provider/api/services'
import { OTP_PROVIDER_QUERY_KEYS } from '@/modules/otp-provider/constants'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import type { paths } from '@/schema'

type UpdateOtpProviderBody =
	paths['/api/admin/otp-provider/{id}']['put']['requestBody']['content']['application/json']
type UpdateOtpProviderResponse =
	paths['/api/admin/otp-provider/{id}']['put']['responses']['200']['content']['application/json']

const useMutationUpdateOtpProvider = () => {
	const queryClient = useQueryClient()

	return useMutation<
		UpdateOtpProviderResponse,
		Error,
		{ id: string; body: UpdateOtpProviderBody }
	>({
		mutationFn: ({ id, body }) =>
			OtpProviderService.updateOtpProvider(id, body),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: OTP_PROVIDER_QUERY_KEYS.PROVIDERS.ALL,
			})
			toast.success('อัปเดตผู้ให้บริการ OTP สำเร็จ')
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})
}

export default useMutationUpdateOtpProvider
